import { DownloadV2, SharedButton } from "@components";
import { dateFormat } from "@configs";
import { ICdicCoupon, ICoupon, IFormExportValues } from "@interfaces";
import { useNotify } from "@utils";
import { Button, Checkbox, Col, DatePicker, Divider, Drawer, Form, Row, Select, Tooltip } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface IProps {
  data: ICdicCoupon[];
  handleExport: (params: IFormExportValues) => void;
}

const options = [
  { label: 'Active', value: 'Active'},
  { label: 'Expired', value: 'Inactive'},
  { label: 'Redeemed', value: 'Redeemed'},
];
const dateStyle = { width: "100%", height: 48 };
const rangePresets: {
  label: string;
  value: [Dayjs, Dayjs];
}[] = [
  { label: "Last 7 Days", value: [dayjs().add(-7, "d"), dayjs()] },
  { label: "Last 14 Days", value: [dayjs().add(-14, "d"), dayjs()] },
  { label: "Last 30 Days", value: [dayjs().add(-30, "d"), dayjs()] },
  { label: "Last 60 Days", value: [dayjs().add(-60, "d"), dayjs()] },
];
const { RangePicker } = DatePicker;

export const ExportSidebarCdic = ({ data, handleExport }: IProps) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const { success, error, info } = useNotify();
  
  const initValue: IFormExportValues = {
    couponFamilyId: null,
    status: [] as string[],
  };
  const onFinish = (values: IFormExportValues) => {
    handleExport(values);
  };
  return (
    <div>
    <Tooltip title={t("page.export_data_by_filter")}>
      <Button
        type="primary"
        onClick={()=> setOpen(!open)}
        style={{background: "#00AA67", color:"#fff"}}
        >
          Export data by Coupon Family
      </Button>
    </Tooltip>
    <Drawer
        title="Export Coupons"
        placement={'right'}
        closable={false}
        onClose={() => setOpen(false)}
        open={open}
        key={'right'}
      >
        <div>
          <Form layout="vertical" initialValues={initValue} onFinish={onFinish}>
            <Row>
              <Col>
                <Form.Item label={t("page.coupon_status")} name="status">
                  <Checkbox.Group style={{ width: "100%" }}>
                    {options.map((item) => (
                      <Checkbox key={item.value} value={item.value}>{item.label}</Checkbox>
                    ))}
                  </Checkbox.Group>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Divider />
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item label={t("page.select_date_range")} name="date">
                  <RangePicker
                    format={dateFormat}
                    style={dateStyle}
                    presets={rangePresets}
                    size="large"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item>
                    <SharedButton
                    type="primary"        
                    icon={<DownloadV2 />}
                    size="middle"
                    htmlType="submit"
                      style={{background: "#00AA67", color:"#fff"}}
                    >
                    {t("page.export_coupons")}
                    </SharedButton>
                </Form.Item>
              </Col>
            </Row>
          </Form>

        </div>
        
      </Drawer>
      </div>
  );
};